
<template>
<v-app>
  <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

    <section  style="height: 500px; background-color:#393E46;" >

        <v-row
            align="center"
            justify="center"
        >
          <v-col
              class="text-center ma-4"
              cols="10"
              lg="9"
              md="9"
              sm="10"
              style="height: 100px;"
          >
            <h1 class="text-lg-h1 text-md-h1 text-h5 text-center font-weight-bold" style="font-family: ProLamina">
               VENDE Y COMPRA ENTRADAS DE FORMA SEGURA
            </h1>
            <h3 class="subheading mt-4 text-lg-h5 text-md-h5 text-sm-h5 text-h6">
Tunay es la forma más segura, práctica y transparente para vender y comprar entradas para conciertos, eventos , festivales, ferias y otras actividades.
              Támbien nos enfocamos en los locales que quieran una forma fácil y rápida para el ingreso de sus invitados, así como el manejo de sus relaciones públicas.
            </h3>
          </v-col>

          <v-col lg="3" md="3" sm="12" cols="12" class="text-center ">
          </v-col>
        </v-row>



    </section>

      <section class="pt-6">
        <v-row>
          <v-col cols="12">
            <h1 class="text-center text-h2">Por qué Tunay</h1>
          </v-col>
        </v-row>
        <v-row class="text-center" justify="center" align="center">
          <v-col cols="12" lg="2" md="2" sm="12">
            <v-icon x-large>fas fa-shield-alt</v-icon>
          </v-col>
          <v-col cols="10" lg="6" md="6" sm="10">
            <v-row>
              <v-col cols="12">
                <h2 class="text-left">Seguro</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify " cols="12">
                Tunay es seguro.  Gracias a la colaboración con organizadores y proveedores de eventos, ofrecemos e-tickets que son 100% válidas. Los E-Tickets son nominadas esto significa que además del QR  tienen el nombre de la persona que la adquirio, pero comprendemos el libre mercado por lo que también pueden ser transferibles.
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="text-center" justify="center" align="center">
          <v-col cols="12" lg="2" md="2" sm="12">
          <v-icon x-large>fas fa-paper-plane</v-icon>
          </v-col>
          <v-col cols="10" lg="6" md="6" sm="10">
            <v-row>
              <v-col cols="12">
                <h2 class="text-left">Fácil Uso</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify" cols="12">
                Para crear un evento o fiesta bastan unos pocos clicks. Solo tienes crearlo e introducir la información necesaria. Una vez creado el evento/fiesta, no tienes que preocuparte de nada. Te enviaremos una notificación cuando la entrada haya sido vendida y te transferiremos el dinero en un plazo de 3 días laborables. Comprar entradas también es muy sencillo. Puedes pagar cómodamente a través de nuestra webapp y la entrada aparecerá automáticamente en tu cuenta de Tunay. ¡También te la enviamos por correo electrónico!     </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>
      <section>
<adsense ad-slot="5611925611" ad-format="auto" ad-client="ca-pub-2457058330866327" ad-style="display:block"></adsense>
      </section>
    </v-main>
    <piepagina/>
  <v-overlay :value="overlay">
    <v-img
        src="@/assets/loadtunay.gif"

    />
  </v-overlay>


  </v-app>
</template>

<script>
import axios from 'axios';


import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import moment from "moment-timezone";
import {mapGetters} from "vuex";
import store from "@/store";
import Adsense from "@/components/modulo/adsensed";
import Cabecerabaja from "@/components/general/cabecerabaja";


  export default {
    name: 'homepage',
    title: 'Tunay Mi acceso de bolsillo',
    components: {
      Cabecerabaja,
      Adsense,
    cabecera,
    piepagina,
  },
    data () {
      return {
        fiestas: [],
        eventos: [],
        email: '',
        tab: null,
        codigoUnico:'',
        rese:'',
        overlay:false,
        emailRules: [
          v => !!v || 'Se necesita el Email',
          v => /.+@.+/.test(v) || 'E-mail debe ser valido',
        ]
          }
    },
    mounted(){
      if(this.usuario.id>0){
        store.dispatch("conectarse")
      }
      this.traeClientes()
      this.fnBrowserDetect();
    },
    methods: {
      validarcodigo(){
        if(this.codigoUnico!= ''){
        this.$router.push({name:"validaqr",params:{codigo: this.codigoUnico}})
        }
      },
      fnBrowserDetect(){

        let userAgent = navigator.userAgent;

        if(userAgent.match(/chrome|chromium|crios/i)){
          this.rese = "chrome";
        }else if(userAgent.match(/firefox|fxios/i)){
          this.rese = "firefox";
        }  else if(userAgent.match(/safari/i)){
          this.rese = "safari";
        }else if(userAgent.match(/opr\//i)){
          this.rese = "opera";
        } else if(userAgent.match(/edg/i)){
          this.rese = "edge";
        }else{
          this.rese="No browser detection";
        }

      },

      formatDatee(value) {
        return moment(value).locale('es-pe').format("DD MMMM YYYY")
      },
      traeClientes(){
        this.overlay = true;
       axios.get("actos/activas", {
         headers: {
           'Accept': 'application/json',
           'Content-Type': 'application/json;charset=UTF-8'
         }
      })
      .then((response)  => {
        this.fiestas = response.data.filter(x=>x.temporada != null);
        this.eventos = response.data.filter(x=>x.temporada == null)
        this.overlay = false;
      })
      .catch((error)  => {
        console.log(error);
        this.overlay = false;
      });
    },

    },
    computed: {
      // map `this.user` to `this.$store.getters.user`
      ...mapGetters({
        usuario: "usuario",
        conectado: "conectado"
      })
    }
  }
</script>
